<template>
  <el-dialog
    :title="$t('taskCenter.label.taskTeview')"
    :visible.sync="taskReViewStatus"
    v-dialogDrag
    width="700px"
    :close-on-click-modal="false"
  >
    <div class="taskAudit">
      <el-row>
        <span
          >{{ $t("taskCenter.label.taskName")
          }}{{ reiviewTaskData.taskName }}</span
        >
      </el-row>
      <el-row>
        <el-col :span="5"
          ><span
            >{{ $t("taskCenter.label.taskTypes")
            }}{{ formatter(taskTypes, reiviewTaskData.taskType) }}</span
          ></el-col
        >
        <el-col :span="5" :title="reiviewTaskData.creator"
          ><span
            >{{ $t("taskCenter.label.creators")
            }}{{ reiviewTaskData.creator }}</span
          ></el-col
        >
      </el-row>
      <el-table
        :data="reviewTasktableData"
        style="width: 100%; margin-top: 15px"
        max-height="380"
      >
        <el-table-column
          prop="executorName"
          :label="$t('taskCenter.label.doPersons')"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="status"
          :label="$t('taskCenter.label.doPersonsStaus')"
          align="center"
          :formatter="formatterChildStatus"
        >
        </el-table-column>
        <!-- <el-table-column :label="$t('taskCenter.label.score')" prop="score">
            <template slot-scope="scope">
              <el-select v-model="scope.row.selector" :placeholder="$t('taskCenter.placeholder.choosePlease')" style="width: 50%" >
                <el-option v-for="item in taskLevelOption" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column> -->
      </el-table>
      <el-row>
        <el-col class="el-form-item is-required review-opinions">
          <span class="standard el-form-item__label">{{
            $t("taskCenter.label.conmments")
          }}</span>
          <el-input
            type="textarea"
            v-model="reviewDesc"
            :rows="5"
            class="standard"
          ></el-input>
          <p class="review-opinions-limit">
            <span>{{ reviewDescTotal }}</span>
            <span> / 100</span>
          </p>
        </el-col>
      </el-row>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="taskReviewSubmit(1)">{{
        $t("taskCenter.button.review")
      }}</el-button>
      <el-button @click="taskReviewSubmit(2)">{{
        $t("taskCenter.button.refuse")
      }}</el-button>
      <el-button @click="close">{{ $t("taskCenter.button.cancel") }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { Dic } from "$utils";
export default {
  props: {
    taskAuditInfo: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      taskTypes: Dic.find("SENU010"), // 类型
      childStatus: Dic.find("SENU055"), // 子任务状态
      taskReViewStatus: false,
      reiviewTaskData: {
        taskName: "",
        taskType: "",
        creator: "", // creatorName
        code: "",
        taskLevel: [],
      },
      reviewDesc: "",
      reviewDescTotal: 0,
      taskLevelOption: [
        {
          value: "1",
          label: this.$t("taskCenter.label.olevel"),
        },
        {
          value: "2",
          label: this.$t("taskCenter.label.tlevel"),
        },
        {
          value: "3",
          label: this.$t("taskCenter.label.thrlevel"),
        },
        {
          value: "4",
          label: this.$t("taskCenter.label.folevel"),
        },
        {
          value: "5",
          label: this.$t("taskCenter.label.flevel"),
        },
      ],
      reviewTasktableData: [],
    };
  },
  watch: {
    reviewDesc(newName, oldName) {
      this.reviewDescTotal = newName.length;
    },
  },
  methods: {
    formatterChildStatus(row, column) {
      let rtn = "";
      this.childStatus.map((item) => {
        if (item.value == row.status) {
          rtn = item.label;
        }
      });
      return rtn;
    },
    formatter(dataList, value) {
      let rtn = "";
      dataList.map((item) => {
        if (item.value == value) {
          rtn = item.label;
        }
      });
      return rtn;
    },
    // 获得审核信息（回填）
    getAuditInfo() {
      this.reiviewTaskData = this.taskAuditInfo.taskInfo;
      this.reviewTasktableData = this.taskAuditInfo.subTaskInfoList;
      this.reviewTasktableData.map((item) => {
        this.$set(item, "selector", "4");
      });
    },
    // 复核按钮触发
    taskReviewSubmit(status) {
      if (this.reviewDesc.length === 0) {
        this.$message.error(this.$t("taskCenter.message.disableNull"));
        return;
      } else if (this.reviewDescTotal > 100) {
        this.$message.error(this.$t("taskCenter.message.commentLen"));
        return;
      }
      let newArray = [];
      for (var i = 0; i < this.reviewTasktableData.length; i++) {
        let newObj = {
          executor: this.reviewTasktableData[i].executor,
          // score: this.reviewTasktableData[i].selector
          score: 4,
        };
        if (this.reviewTasktableData[i].status === 30) {
          newArray.push(newObj);
        }
      }
      let taskAssignInfo = {
        taskCode: this.reiviewTaskData.code,
        checkStatus: status,
        checkOpinion: this.reviewDesc,
        executorScoreList: newArray,
      };
      this.$emit("childByData", taskAssignInfo);
    },
    open() {
      this.reviewDesc = "";
      this.taskReViewStatus = true;
    },
    close() {
      this.reviewDesc = "";
      this.taskReViewStatus = false;
    },
  },
};
</script>
<style>
/* .taskAudit {
  margin-top: -30px;
} */
.el-row {
  padding: 5px 0;
}
.standard {
  float: left;
}
.review-opinions {
  position: relative;
}
.review-opinions-limit {
  position: absolute;
  bottom: 2px;
  right: 20px;
  color: #999;
  font-size: 14px;
}
</style>
